import {Component, Inject, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import {MatButton} from '@angular/material/button';
import {QRCodeComponent} from 'angularx-qrcode';
import {TranslateModule} from '@ngx-translate/core';

export interface qrDialogDataSchema {
  qrCodeUri: string;
  needQrTransformation?: boolean;
  dialogTitle?: string;
  dialogMessage?: string;
  alternativeButtonText?: string;
  alternativeButtonLink?: string;
}

@Component({
  selector: 'app-dialog-qr-code',
  imports: [
    QRCodeComponent,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatButton,
    CommonModule,
    TranslateModule
  ],
  templateUrl: './dialog-qr-code.component.html',
  styleUrl: './dialog-qr-code.component.scss',
  standalone: true
})

export class DialogQrCodeComponent implements OnInit{

  qrCodeUri!: string;
  needQrTransformation?: boolean = false;
  dialogTitle?: string;
  dialogMessage?: string;
  alternativeButtonText?: string;
  alternativeButtonLink?: string;

  constructor(
    public dialogRef: MatDialogRef<DialogQrCodeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: qrDialogDataSchema
    ) {
      this.qrCodeUri = data.qrCodeUri;
      if (data.needQrTransformation) this.needQrTransformation = data.needQrTransformation;
      if (data.dialogTitle) this.dialogTitle = data.dialogTitle;
      if (data.dialogMessage) this.dialogMessage = data.dialogMessage;
      if (data.alternativeButtonText) this.alternativeButtonText = data.alternativeButtonText;
      if (data.alternativeButtonLink) this.alternativeButtonLink = data.alternativeButtonLink;
  }

  ngOnInit() {
  }
}
